module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore
    }
  }, [_c('banner'), _vm._v(" "), _c('quick'), _vm._v(" "), _c('div', {
    staticClass: "recs"
  }, _vm._l((_vm.recommendations), function(item, index) {
    return _c('recommendation', {
      key: index,
      attrs: {
        "value": item
      }
    })
  }), 1), _vm._v(" "), (_vm.unreadVisible) ? _c('router-link', {
    staticClass: "unread",
    attrs: {
      "to": {
        name: 'news'
      },
      "href": "javascript:;"
    }
  }, [_vm._v("您有未读消息")]) : _vm._e(), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78520c32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/index.vue
// module id = 336
// module chunks = 0